import { Building2 } from 'lucide-react'
import { EmptyState, PageHeader } from '@/components/ui'

export function VertraegeKundensichtPage() {
  return (
    <div className="p-6 space-y-6">
      <PageHeader title="Kundensicht 360°" />
      <EmptyState
        icon={<Building2 />}
        title="Kundensicht in Entwicklung"
        description="Die 360°-Kundensicht für Verträge wird in Kürze verfügbar sein."
      />
    </div>
  )
}
